import { render, staticRenderFns } from "./ClientFamilyParentTree.vue?vue&type=template&id=58383287"
import script from "./ClientFamilyParentTree.vue?vue&type=script&lang=js"
export * from "./ClientFamilyParentTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports